export const isNotNull = <T extends any>(value: T): value is Exclude<T, null> => value !== null;

export const isUndefined = <T extends any>(value: T): value is Exclude<T, undefined> =>
  typeof value === 'undefined';
